import React from 'react'
import ConstantsUtil from '../../../../context/constantsUtil'
import GeneralServices from '../../../../app/service/generalServices'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import DialogFooter from '../../../dialogFooter'
import RelatorioFechamentoCaixaTable from '../../fechamentoCaixa/relatorioFechamentoCaixaTable'
import FichaDeRecebimentoConsolidadaTable from '../../../fichaDeRecebimento/fichaDeRecebimentoConsolidadaTable'
import ProvisaoTable from '../../../contasAPagar/provisoes/provisaoTable'
import { AuthContext } from '../../../../main/authProvider'
import TipoDePagamentoService from '../../../../app/service/contasAPagar/tipoDePagamentoService'
import HandleErrorService from '../../../../app/service/handleErrorService'
import TableFilters from '../../../tableFilters'
import DREFichaBancariaDialog from '../../DRE/DREFichaBancariaDialog'
import TiposDeRecebimentoService from '../../../../app/service/tiposDeRecebimentoService'
import ProvisoesPorProdutoTable from '../../../contasAPagar/provisoes/provisoesPorProdutoTable'
import SelectMenu from '../../../selectMenu'
import AuthService from '../../../../app/service/authService'
import LancamentoDataValorTable from '../../../estoque/lancamentoDataValorTable'

class DRECompetenciaMensalDetalhamentoDialog extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.provisaoTableRef = React.createRef();
        this.provisoesPorProdutoTableRef = React.createRef();
        this.fichaDeRecebimentoTableRef = React.createRef();
        this.tipoDePagamentoService = new TipoDePagamentoService();
        this.tiposDeRecebimentoService = new TiposDeRecebimentoService()
        this.tableFilters = new TableFilters();
    }

    state = {

        
        didUpdate: false,
        
        displayFechamentoCaixaTable: false,

        displayReceitaDeServicosTable: false,

        descricaoDetalhamento: '',

        displayFichaDeRecebimentoConsolidadaTable: false,
        fichaDeRecebimento: {},
        empresaIndex: 0,
        selectedEmpresa: null,

        displayProvisaoTable: false,
        searchProvisaoResult: '',

        loading: false,

        displayDialogRendApAuto: false,
        forceUpdateDialog: false,
        tipoDeRecebimentoRendApAutoToView: null,

        displayProvisaoPorProdutosTable: false,
        tiposProdutosList: [],

        empresasSelectList: [],

    }

    componentDidUpdate(){
        // console.log("componentDidUpdate detalhamento dialog fora: ", this.props.visible, this.state.didUpdate, this.props.item)
        if(this.props.visible && !this.state.didUpdate){
            // console.log("componentDidUpdate detalhamento dialog dentro: ", this.props.visible, this.state.didUpdate, this.props.item)
            this.initialize()
        }
    }

    initialize = async () => {
        await this.setState({didUpdate: true})
        await this.buildEmpresasSelectList()
        this.searchDetalhamento()
        // console.log("BBBBBBBB didUpdate true")
    }

    buildEmpresasSelectList = async () => {
        // console.log("buildEmpresasSelectList isExpAuto: ", this.props.isExportacaoAutomatica)
        if(this.props.unificar){
            let empresasSelectList = this.props.selectedEmpresas.map(empresa => {return {label: empresa.nome, value: empresa.id}})
            let nomeEmpresaLogada = AuthService.getEmpresa()
            // console.log("buildEmpresasSelectList empresasSelectList: ", empresasSelectList)
            // console.log("buildEmpresasSelectList empresa logada: ", nomeEmpresaLogada)

            const emrpesaLogadaNaSelectList = empresasSelectList.find(empresa => empresa.label === nomeEmpresaLogada);
            if (emrpesaLogadaNaSelectList) {
                empresasSelectList = [emrpesaLogadaNaSelectList, ...empresasSelectList.filter(empresa => empresa.label !== nomeEmpresaLogada)];
            }

            // console.log("buildEmpresasSelectList empresasSelectList FINAL: ", empresasSelectList)

            await this.setState({empresasSelectList})

        }
    }


    searchDetalhamento = () => {
        // console.log("this.props.grupo: ", this.props.grupo)
        // console.log("this.props.item: ", this.props.item)

        switch(this.props.grupo.tipoDescricao){
           
            case ConstantsUtil.DRECompetenciaGrupoReceitaBruta:
                
            if(!this.props.item) return

                if(this.props.item.nome === ConstantsUtil.DRECompetenciaItemReceitaDeVendas){
                    this.setState({displayFechamentoCaixaTable: true})
                    this.setState({descricaoDetalhamento: "Fechamento de Caixa"})
                }
                else if(this.props.item.nome === ConstantsUtil.DRECompetenciaItemReceitaDeServicos){
                    this.setState({displayReceitaDeServicosTable: true})
                    this.setState({descricaoDetalhamento: "Receita de Serviços"})
                }
                break;
            
            case ConstantsUtil.DRECompetenciaGrupoDeducoesReceita:
                this.openFichaDeRecebimentoConsolidada()
                this.setState({descricaoDetalhamento: "Comissões da Ficha de Recebimento"})
                break;

            case ConstantsUtil.DRECompetenciaGrupoImpostos:
                this.openConferenciaProvisaoPagamento(false)
                this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
                break;

            case ConstantsUtil.DRECompetenciaGrupoCMV:
                this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
                this.openProvisoesPorProdutos(this.props.tiposProdutosDescricoesCMV)
                break;

            case ConstantsUtil.DRECompetenciaGrupoReceitaFinanceira:
                if(this.props.item && this.props.item.nome === ConstantsUtil.DRECompetenciaItemReceitaAplicacoesFinanceiras){
                    this.mostraDetalhamentoRendApAuto()
                }
                else if(this.props.item && this.props.item.nome === ConstantsUtil.DRECompetenciaItemReceitaBonificacao){
                    this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
                    this.openProvisoesPorProdutos([ConstantsUtil.tipoProdutoBonificacaoLabel])
                }
                break;

            // case ConstantsUtil.DRECompetenciaGrupoDespesasPessoal:
            //     this.openConferenciaProvisaoPagamento(true)
            //     this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
            //     break;

            // case ConstantsUtil.DRECompetenciaGrupoDespesasFuncionamento:
            //     this.openConferenciaProvisaoPagamento(true)
            //     this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
            //     break;

            // case ConstantsUtil.DRECompetenciaGrupoOutrasDespesas:
            default:
                if(this.props.item.isProduto){
                    this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
                    this.openProvisoesPorProdutos([this.props.item.tipoProduto.descricao])
                }
                else{
                    this.openConferenciaProvisaoPagamento(true)
                    this.setState({descricaoDetalhamento: ConstantsUtil.provisoesDePagamentoHeaderLabel})
                }
                break;

        }
    }

    mostraDetalhamentoRendApAuto = () => {
        this.tiposDeRecebimentoService.searchRendApAutoAsDreDto()
        .then(async response => {
            await this.setState({tipoDeRecebimentoRendApAutoToView: response.data})
            this.setState({forceUpdateDialog: true})
            this.setState({displayDialogRendApAuto: true})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }
        
    openFichaDeRecebimentoConsolidada = async () => {

        // console.log("\n\n")
        console.log("openFichaDeRecebimentoConsolidada: ", JSON.parse(JSON.stringify(this.state.empresasSelectList)))
        
        if(this.state.empresasSelectList && this.state.empresasSelectList.length > 0){
            console.log("open this.state.empresaIndex: ", this.state.empresaIndex)
            let selectedEmpresa = this.state.empresasSelectList[this.state.empresaIndex].value
            console.log("open this.state.selectedEmpresa: ", this.state.selectedEmpresa)
            await this.setState({selectedEmpresa})
        }

        console.log("\n\n")
        
        await this.setState({fichaDeRecebimento:
            {
                initialDate: this.props.dataInicial,
                finalDate: this.props.dataFinal,
                dateFilterType: ConstantsUtil.dataLancamentoValue,
                doAutoSearch: true,
                
            }
        })
        this.setState({displayFichaDeRecebimentoConsolidadaTable: true})
    }

    onSuccessSearchFichaDeRecebimento = async (fichaDeRecebimento) => {

        console.log("\n\n")
        console.log("onSuccessSearchFichaDeRecebimento this.state.empresasSelectList: ", this.state.empresasSelectList)
        console.log("onSuccessSearchFichaDeRecebimento this.state.empresaIndex: ", this.state.empresaIndex)
        console.log("onSuccessSearchFichaDeRecebimento this.state.selectedEmpresa: ", this.state.selectedEmpresa)
        await this.setState({fichaDeRecebimento})
        
        console.log("onSuccessSearchFichaDeRecebimento this.props.isExportacaoAutomatica: ", this.props.isExportacaoAutomatica)
        if(this.props.isExportacaoAutomatica){
            
            
            console.log("onSuccessSearchFichaDeRecebimento EXPORTANDO EMPRESA: ", this.getNomeEmpresa())
            this.fichaDeRecebimentoTableRef.current.exportXLSX()
            await this.setState({displayFichaDeRecebimentoConsolidadaTable: false})

            if(!this.state.empresasSelectList || this.state.empresasSelectList.length == 0){
                /*
                Não é unificação.
                Só tinha uma empresa, a logada.
                */
               this.hideDialog()
               AuthService.stopBlockUi()
                return;
            }

            let empresaIndex = this.state.empresaIndex
            empresaIndex++
            let size = this.state.empresasSelectList.length

            console.log("index: ", empresaIndex)

            if(empresaIndex < size){
                // let empresa = this.state.empresasSelectList[empresaIndex]
                // await this.setState({selectedEmpresa: empresa.value})

                console.log("abrindo novamente")
                await this.setState({empresaIndex})
                this.openFichaDeRecebimentoConsolidada()
            }
            else{
                console.log("Acabou")
                await this.setState({
                    empresaIndex: 0,
                    selectedEmpresa: null
                })
                this.hideDialog()
                AuthService.stopBlockUi()
                return;
            }            

        }

    }

    openConferenciaProvisaoPagamento = (fromGrupoDePagamento) => {
        
        this.setState({displayProvisaoPorProdutosTable: false})

        let obj = {
            filterTypeDate: ConstantsUtil.dataLancamentoValue,
            initialDate: this.props.dataInicial,
            finalDate: this.props.dataFinal,
        }

        if(fromGrupoDePagamento){
            obj.filterType = ConstantsUtil.filtroProvisaoGrupoDePagamentoNome
            obj.nomeGrupoDePagamento = this.props.item.nome
        }
        else{
            obj.filterType = ConstantsUtil.filtroProvisaoTipoDePagamentoNome
            obj.nomeTipoDePagamento = this.props.item.nome

        }

        //Define a função onSuccess
        let onSuccess = async (responseData) => {
            
            await this.setState({searchProvisaoResult: responseData.dados})

            if(this.props.isExportacaoAutomatica){
                this.realizaExportacaoAutomaticaProvisao()
            }

        }

        //Define a função onFinally
        let onFinally = () => {
            this.setState({loading: false})
        }

        this.setState({loading: true})

        //Realiza a busca
        // console.log("realiza a busca this.generalServices.searchProvisoes: ", obj.nomeTipoDePagamento)
        this.generalServices.searchProvisoes(
            obj,
            onSuccess,
            onFinally,
            this.props.unificar,
            this.props.selectedEmpresas
        )

        this.setState({displayProvisaoTable: true})

    }

    realizaExportacaoAutomaticaProvisao = () => {
        let listToExport = this.provisaoTableRef.current.getListToExport()
        listToExport.pop() //remove a última linha de valor total. Deixa apenas os lançamentos
        console.log("buscou: ", listToExport)
        console.log("verifica state antes de callback: ", this.props.visible, this.state.didUpdate)
        this.props.callBackListToExportDetalhamento(listToExport, this.props.indexExportacao, ConstantsUtil.exportListProvisaoNormal)
    }

    openProvisoesPorProdutos = async (tiposProdutosList) => {
        // console.log("openProvisoesPorProdutos: ", tiposProdutosList)
        await this.setState({displayProvisaoTable: false})
        tiposProdutosList = tiposProdutosList.map(tipoProduto => {return {descricao: tipoProduto} })
        await this.setState({tiposProdutosList: tiposProdutosList})
    
        // await this.generalServices.sleep(5000)

        this.setState({displayProvisaoPorProdutosTable: true})
    }

    onSuccessSearchProvisoesProdutos = async () => {
        if(this.props.isExportacaoAutomatica){
            
            let uuid = crypto.randomUUID();
            console.log("uuid: ", uuid, this.props.item)

            if(!this.provisoesPorProdutoTableRef || !this.provisoesPorProdutoTableRef.current){
                console.log("esperando para ver se constroi this.provisoesPorProdutoTableRef ", uuid)
                await this.generalServices.sleep(500)
                console.log("acabou espera ", uuid)
            }

            console.log("fora ", uuid)

            let listToExport = this.provisoesPorProdutoTableRef.current.getListToExport()

            console.log("onSuccessSearchProvisoesProdutos uuid: ", uuid, this.props.item, listToExport)
            this.setState({displayProvisaoPorProdutosTable: false})
            this.props.callBackListToExportDetalhamento(listToExport, this.props.indexExportacao, ConstantsUtil.exportListProvisaoProdutos)
        }
    }

    hideDialog = async () => {
        // console.log("chamou hideDialog no detalhamento dialog")
        this.props.hideDialog()
        await this.resetState()
        await this.setState({didUpdate: false})
        await this.setState({descricaoDetalhamento: ''})
    }

    resetState = async () => {
        await this.setState({
            tipoDeRecebimentoRendApAutoToView: null,
            displayFechamentoCaixaTable: false,
            displayDialogRendApAuto: false,
            displayFichaDeRecebimentoConsolidadaTable: false,
            displayProvisaoPorProdutosTable: false,
            displayReceitaDeServicosTable: false,
        })
    }

    handleSelectEmpresaChange = async (event) => {
        const name = event.target.name
        const value = event.target.value
        await this.setState({ [name]: value })
        this.researchDetalhamento()
        // console.log("this.state.selectedEmpresa: ", this.state.selectedEmpresa)
    }

    researchDetalhamento = async () => {
        if(this.state.displayFechamentoCaixaTable){
            this.setState({displayFechamentoCaixaTable: false})
            this.setState({displayFechamentoCaixaTable: true})
        }
        
        else if(this.state.displayFichaDeRecebimentoConsolidadaTable){
            await this.setState({displayFichaDeRecebimentoConsolidadaTable: false})
            let fichaDeRecebimento = this.state.fichaDeRecebimento
            fichaDeRecebimento.doAutoSearch=true
            fichaDeRecebimento.dateFilterType = fichaDeRecebimento.dateFilterTypeEnum
            fichaDeRecebimento.initialDate = fichaDeRecebimento.initialDate.replaceAll("/", "-")
            fichaDeRecebimento.finalDate = fichaDeRecebimento.finalDate.replaceAll("/", "-")
            await this.setState({fichaDeRecebimento})
            this.setState({displayFichaDeRecebimentoConsolidadaTable: true})
        }

    }

    researchAllDRE = () => {
        if(this.state.displayFechamentoCaixaTable){
            this.setState({displayFechamentoCaixaTable: false})
        }
        else if(this.state.displayReceitaDeServicosTable){
            this.setState({displayReceitaDeServicosTable: false})
        }
        else if(this.state.displayFichaDeRecebimentoConsolidadaTable){
            this.setState({displayFichaDeRecebimentoConsolidadaTable: false})
        }
        else if(this.state.displayProvisaoTable){
            this.setState({displayProvisaoTable: false})
        }
        else if(this.state.displayDialogRendApAuto){
            this.setState({displayDialogRendApAuto: false})
        }
        else if(this.state.displayProvisaoPorProdutosTable){
            this.setState({displayProvisaoPorProdutosTable: false})
        }
        this.props.searchAllDRE()
    }

    getHeader = () => {
        // console.log("this.props.item: ", this.props.item)
        // console.log("this.props.grupo: ", this.props.grupo)
        return `${this.props.item ? this.props.item.nome : this.props.grupo.tipoDescricao} (${this.props.dataInicial} - ${this.props.dataFinal}) (${this.state.descricaoDetalhamento})`
    }

    getNomeEmpresa = () => {
        // console.log("this.state.empresasSelectList: ", this.state.empresasSelectList)
        // console.log("this.state.selectedEmpresa: ", this.state.selectedEmpresa)
        let empresaObj = this.state.empresasSelectList.find(empresa => empresa.value == this.state.selectedEmpresa)
        // console.log("empresa: ", empresaObj)
        return empresaObj ? empresaObj.label : ''
    }

    render(){

        const footer = (
            <DialogFooter hideDialog = {this.hideDialog} disabled/>
        )

        const renderDetalhamento = () => {

            return (
                <>
                    {renderFechamentoDeCaixaTable()}
                    {renderReceitaDeServicosTable()}
                    {renderFichaDeRecebimentoConsolidadaTable()}
                    {renderProvisaoTable()}
                    {renderProvisaoPorProdutosTable()}
                </>
            )
        }

        const renderFechamentoDeCaixaTable = () => {
            if(this.state.displayFechamentoCaixaTable){
                return (
                    <RelatorioFechamentoCaixaTable
                        dataInicial = {this.props.dataInicial}
                        dataFinal = {this.props.dataFinal}
                        especificar = {false}
                        scrollHeight="50vh"
                        hidePaginator
                        specificEmpresaId={this.state.selectedEmpresa}
                    />
                )
            }
        }

        const renderReceitaDeServicosTable = () => {
            if(this.state.displayReceitaDeServicosTable){
                return (
                    <LancamentoDataValorTable
                        initialDate={this.props.dataInicial}
                        finalDate={this.props.dataFinal}
                        viewDialog={this.viewDialog}
                        modo={ConstantsUtil.modoReceitaDeVendas}
                        unificar={this.props.unificar}
                        empresasList={this.props.selectedEmpresas}
                    />
                )
            }
        }

        const renderFichaDeRecebimentoConsolidadaTable = () => {
            // console.log("renderFichaDeRecebimentoConsolidadaTable AAAAAAAAAAAA: ", this.state.displayFichaDeRecebimentoConsolidadaTable)
            if(this.state.displayFichaDeRecebimentoConsolidadaTable) {
                return (
                    <>
                    <FichaDeRecebimentoConsolidadaTable
                        ref={this.fichaDeRecebimentoTableRef}
                        header={this.getHeader()}
                        nomeEmpresa={this.getNomeEmpresa()}
                        fichaDeRecebimento={this.state.fichaDeRecebimento}
                        updateProps={this.onSuccessSearchFichaDeRecebimento}
                        insideDialog
                        specificEmpresaId={this.state.selectedEmpresa}
                        sortType={ConstantsUtil.fichaDeRecebimentoSortTypeComissao}
                        isExportacaoAutomatica={this.props.isExportacaoAutomatica}
                    />
                    </>
                )
            }
        }

        const renderProvisaoTable = () => {
            if(this.state.displayProvisaoTable) {
                return (
                    <ProvisaoTable
                        ref={this.provisaoTableRef}
                        searchProvisaoResult={this.state.searchProvisaoResult}
                        perfil = {this.context.perfil}
                        loading={this.state.loading}
                        search={this.researchAllDRE}
                        insideDialog
                        insideDre
                        initialDate={this.props.dataInicial}
                        finalDate={this.props.dataFinal}
                        unificar={this.props.unificar}
                        itemDre={this.props.item}
                        grupoDre={this.props.grupo}
                        isExportacaoAutomatica={this.props.isExportacaoAutomatica}
                    />
                )
            }
        }

        const renderProvisaoPorProdutosTable = () => {
            if(this.state.displayProvisaoPorProdutosTable) {
                return(
                    <ProvisoesPorProdutoTable
                        ref={this.provisoesPorProdutoTableRef}
                        header={this.getHeader()}
                        grupo={this.props.grupo}
                        initialDate={this.props.dataInicial}
                        finalDate={this.props.dataFinal}
                        tipoProdutoList={this.state.tiposProdutosList}
                        unificar={this.props.unificar}
                        empresasList={this.props.selectedEmpresas}
                        insideDialog
                        insideDre
                        isExportacaoAutomatica={this.props.isExportacaoAutomatica}
                        onSuccessSearch={this.onSuccessSearchProvisoesProdutos}
                    />
                )
            }
        }

        const renderTopOptions = () => {
            return (
                <div 
                    className='row'
                    style={{marginTop: '0.1rem'}}
                >
                    
                    <div className='col-md-2'>
                        {renderValorItem()}
                    </div>

                    <div className='col-md-6'>
                    </div>

                    <div className='col-md-4'>
                        {renderSelectEmpresa()}
                    </div>

                </div>
            )
        }

        const renderValorItem = () => {
            return (
                <>
                    <Button
                        label={`Valor: ${GeneralServices.showFormattedIfNotNull(this.props.item ? this.props.item.valor : this.props.grupo.total, true)}`}
                        className={`small-font `}
                        style={{maxHeight: '10px', width: '12rem',}}
                    />                
                </>
            )
        }

        const renderSelectEmpresa = () => {
            if(this.props.unificar && (this.state.displayFechamentoCaixaTable || this.state.displayFichaDeRecebimentoConsolidadaTable) ){
                return (
                    <>
                        <SelectMenu
                            className={"form-control "}
                            name="selectedEmpresa"
                            list={this.state.empresasSelectList}
                            value={this.state.selectedEmpresa}
                            onChange={this.handleSelectEmpresaChange}
                        />
                    </>
                )
            }
        }

        const renderCommomDetalhamentoDialog = () => {
            if(this.props.isExportacaoAutomatica){
                return(
                    <>
                        {renderDetalhamento()}
                    </>
                )
            }

            return (
                <Dialog
                    header={this.getHeader()}
                    visible={this.props.visible}
                    style={{ width: '98vw', height: '95vh' }}
                    modal
                    className="p-fluid"
                    footer={footer}
                    onHide={this.hideDialog}
                >
                    {renderTopOptions()}

                    {renderDetalhamento()}

                </Dialog>                
            )
        }

        const renderDialogRendApAuto = () => {
            return(
                <>
                    <DREFichaBancariaDialog
                        visible={this.props.visible}
                        headerPrefix="Fluxo de Caixa Realizado"
                        initialDate={this.props.dataInicial}
                        finalDate={this.props.dataFinal}
                        element={this.state.tipoDeRecebimentoRendApAutoToView}
                        unificarEmpresas={this.props.unificar}
                        selectedEmpresas={this.props.selectedEmpresas}
                        forceUpdate={this.state.forceUpdateDialog}
                        doneForceUpdate={() => this.setState({forceUpdateDialog: false})}
                        // fichaBancaria={this.state.fichaBancariaToView}
                        // search={this.props.search}
                        recebimento
                        fromDRECompetencia
                        saveAsExcelFile={GeneralServices.saveAsExcelFile}
                        loadingTable={false}
                        hideDialog={this.hideDialog}
                    />
                </>
            )
        }

        const renderDialog = () => {
            if(this.state.displayDialogRendApAuto) {
                return renderDialogRendApAuto()
            }
            else {
                return renderCommomDetalhamentoDialog()
            }
        }

        return (
            <>
                {renderDialog()}
            </>
        )
    }

}

DRECompetenciaMensalDetalhamentoDialog.contextType = AuthContext

export default DRECompetenciaMensalDetalhamentoDialog